<template>
    <v-btn :elevation="0" :style="gradientStyle" :size="size" class="white--text custom-btn pa-2 pl-3 pr-3 ma-1"
        :rounded="rounded" :disabled="disabled" :outlined="outlined" :fab="fab" :color="gradient ? null : color"
        :x-small="xs" :small="sm" :medium="md" :large="lg" :x-large="xl" @click="$emit('click')" :block="block">
        <span v-if="label" class="pa-1">{{ label }}</span>
        <v-icon v-if="icon">{{ icon }}</v-icon>
    </v-btn>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: false,
            default: ""
        },
        icon: {
            type: String,
            required: false,
            default: ""
        },
        color: {
            type: String,
            required: false,
            default: "primary"
        },
        gradient: {
            type: Boolean,
            required: false,
            default: false
        },
        outlined: {
            type: Boolean,
            required: false,
            default: false
        },
        fab: {
            type: Boolean,
            required: false,
            default: false
        },
        rounded: {
            type: Boolean,
            required: false,
            default: false
        },
        block: {
            type: Boolean,
            required: false,
            default: false
        },
        elevation: {
            type: Number,
            required: false,
            default: 4
        },
        size: {
            type: String,
            required: false,
            default: "lg",
            validator: (value) => ["xs", "sm", "md", "lg", "xl"].includes(value)
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        gradientStyle() {
            const shadowColor = this.disabled
                ? "rgba(0, 0, 0, 0.1)"  // Disabled 상태일 때 연한 그림자 적용
                : this.getShadowColor(this.color);

            return {
                background: this.disabled
                    ? "#bdbdbd"  // Disabled 배경 색상
                    : this.gradient
                        ? `linear-gradient(135deg, ${this.getGradientColor(this.color)})`
                        : null,
                boxShadow: this.disabled
                    ? `0px 1px 3px ${shadowColor} !important` // Disabled 상태에서 연한 그림자
                    : `0px 2px 8px ${shadowColor} !important`, // 기본 그림자
                transition: "box-shadow 0.1s ease-in-out"
            };
        },
        xl() { return this.size === "xl"; },
        lg() { return this.size === "lg"; },
        md() { return this.size === "md"; },
        sm() { return this.size === "sm"; },
        xs() { return this.size === "xs"; }
    },
    methods: {
        getGradientColor(color) {
            const red = "#f44336";
            const pink = "#e91e63";
            const purple = "#9c27b0";
            const blue = "#2196f3";
            const green = "#4caf50";
            const yellow = "#fec60a";
            const orange = "#ff9800";
            const black = "#424242";


            const gradientColors = {
                primary: `${orange}, #feb47b`,
                blue: `${blue}, #6dd5ed`,  // 블루 계열
                green: `${green}, #a8e063`, // 그린 계열
                yellow: `${yellow}, #f2c94c`, // 옐로우 계열
                red: `${red}, #ea384d`,  // 레드 계열
                purple: `${purple}, #e100ff`,  // 퍼플 계열
                pink: `${pink}, #ff7eb3`, // 핑크 계열
                black: `${black}, #757575`,  // 블랙-화이트 계열
            };
            return gradientColors[color] || gradientColors.primary;
        },
        getShadowColor(color) {
            const shadowColors = {
                primary: "rgba(255, 152, 0, 0.4)",  // 오렌지톤 그림자
                blue: "rgba(33, 150, 243, 0.3)",  // 블루 계열 그림자
                green: "rgba(76, 175, 80, 0.3)", // 그린 계열 그림자
                yellow: "rgba(254, 198, 10, 0.4)", // 옐로우 계열 그림자
                red: "rgba(244, 67, 54, 0.4)",  // 레드 계열 그림자
                purple: "rgba(156, 39, 176, 0.4)",  // 퍼플 계열 그림자
                pink: "rgba(233, 30, 99, 0.4)", // 핑크 계열 그림자
                black: "rgba(66, 66, 66, 0.3)"  // 연한 블랙 그림자
            };
            return shadowColors[color] || "rgba(0, 0, 0, 0.1)"; // 기본 그림자 색상
        }
    }
}
</script>

<style scoped>
.custom-btn:disabled {
    background: #bdbdbd !important;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1) !important;
    opacity: 0.6;
    cursor: not-allowed;
}

.custom-btn:hover {
    box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.1) !important;
}
</style>